import http from '../../helpers/http';
import {IdApplication} from '../../Constants'
import {ValidatorError} from '../../hooks/templateHooks/useServerErrorValidation'

//Item de Aplicación
export const GetApplicationItem = async (IdApplication) =>{
    const {data} = await http.get(`/JolteonAccess/Application/${IdApplication}`).catch(error=>ValidatorError(error));;
    return data;
}

//Compañias por aplicacion
export const GetCompanyByApplication = async (IdApplication) =>{
    const {data} = await http.get(`/JolteonAccess/Application/Company/${IdApplication}`).catch(error=>ValidatorError(error));;

    return data;
}

//Culturas por aplicacion
export const GetCultureByApplication = async (IdApplication) =>{
    const {data} = await http.get(`/JolteonAccess/Application/Culture/${IdApplication}`).catch(error=>ValidatorError(error));;
   
    return data;
}